import { get } from 'lodash'

export default (item, params = null, value = null) => get(item, params, value)



// WEBPACK FOOTER //
// ./src/filters/get-value.js